var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 901,
    viewBox: "0 0 1920 901",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_1723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 901
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9668C0 6.70084 5.65535 0 12.6316 0H1907.37C1914.34 0 1920 6.70085 1920 14.9668V886.033C1920 894.299 1914.34 901 1907.37 901H12.6315C5.6553 901 0 894.299 0 886.033V14.9668Z",
    fill: "#1C1C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_1723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1417.47 619.814C1417.47 619.814 1683.3 408.224 2047.48 408.618C2411.69 409 1855.64 1092.33 1855.64 1092.33C1855.65 1092.3 1886.46 1053.73 1886.46 1053.73",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.95 604.088C1431.95 604.088 1695.7 385.506 2060.31 388.513C2424.9 391.52 1875.94 1099.67 1875.94 1099.67C1875.95 1099.65 1906.36 1059.68 1906.36 1059.68",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.84 587.874C1446.84 587.874 1708.51 362.277 2073.53 367.909C2438.55 373.544 1896.63 1106.5 1896.63 1106.5C1896.64 1106.48 1926.65 1065.1 1926.65 1065.1",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.29 570.936C1462.29 570.936 1721.9 338.321 2087.36 346.576C2452.82 354.835 1917.91 1112.6 1917.91 1112.6C1917.92 1112.58 1947.53 1069.8 1947.53 1069.8",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.81 553.913C1477.81 553.913 1735.37 314.299 2101.27 325.175C2467.17 336.053 1939.25 1118.64 1939.25 1118.64C1939.27 1118.62 1968.49 1074.43 1968.49 1074.43",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.41 536.806C1493.41 536.806 1748.95 290.168 2115.32 303.663C2481.7 317.165 1960.72 1124.58 1960.72 1124.58C1960.73 1124.55 1989.56 1078.96 1989.56 1078.96",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.06 519.602C1509.06 519.602 1762.59 265.937 2129.47 282.059C2496.35 298.182 1982.27 1130.43 1982.27 1130.43C1982.28 1130.4 2010.71 1083.4 2010.71 1083.4",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.77 502.329C1524.77 502.329 1776.3 241.633 2143.68 260.395C2511.06 279.133 2003.86 1136.23 2003.86 1136.23C2003.88 1136.2 2031.92 1087.8 2031.92 1087.8",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1937.55 251.002C1937.55 251.002 1497.51 384.238 1382.32 695.381C1267.13 1006.5 2592.13 834.468 2592.13 834.468L2517.48 843.689",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1958 236.144C1958 236.144 1525.61 372.378 1407.75 682.176C1289.88 991.971 2587.94 809.167 2587.94 809.167L2514.82 818.999",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978.61 218.781C1978.61 218.781 1553.89 358.01 1433.36 666.462C1312.82 974.912 2583.91 781.359 2583.91 781.359L2512.32 791.799",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1999.43 201.244C1999.43 201.244 1582.37 343.465 1459.17 650.591C1335.97 957.715 2580.08 753.403 2580.08 753.403L2510.02 764.453",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020.41 183.529C2020.41 183.529 1611.04 328.715 1485.18 634.515C1359.32 940.291 2576.46 725.252 2576.46 725.252L2507.92 736.909",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.59 165.734C2041.59 165.734 1639.89 313.905 1511.39 618.355C1382.88 922.804 2573.05 697.025 2573.05 697.025L2506.04 709.291",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2063.59 148.415C2063.59 148.415 1669.57 299.566 1538.44 602.667C1407.3 905.766 2570.51 669.28 2570.51 669.28L2505.03 682.152",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.91 131.156C2085.91 131.156 1699.57 285.284 1565.82 587.033C1432.06 888.803 2568.28 641.617 2568.28 641.617L2504.33 655.097",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2109.6 114.927C2109.6 114.927 1730.95 272.006 1594.58 572.447C1458.21 872.864 2567.44 614.991 2567.44 614.991L2505.02 629.076",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.34 99.4666C2134.34 99.4666 1763.38 259.515 1624.42 558.602C1485.45 857.688 2567.7 589.117 2567.7 589.117L2506.8 603.808",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160.09 84.733C2160.09 84.733 1796.82 247.747 1655.28 545.48C1513.73 843.212 2568.98 563.976 2568.98 563.976L2509.62 579.273",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2186.73 70.6929C2186.73 70.6929 1831.16 236.669 1687.06 533.047C1542.94 829.445 2571.22 539.541 2571.22 539.541L2513.38 555.44",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.5 57.4645C2213.5 57.4645 1865.65 226.376 1718.98 521.441C1572.31 816.483 2573.58 515.96 2573.58 515.96L2517.27 532.463",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2240.29 44.9727C2240.29 44.9727 1900.15 216.838 1750.95 510.545C1601.74 804.251 2576.01 493.078 2576.01 493.078L2521.22 510.183",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265.24 33.6086C2265.24 33.6086 1932.82 208.424 1781.11 500.772C1629.4 793.12 2576.64 471.331 2576.64 471.331L2523.39 489.038",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288.59 23.2618C2288.59 23.2618 1963.91 201 1809.69 492.01C1655.48 783.021 2575.74 450.614 2575.74 450.614L2524.01 468.921",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310.44 13.819C2310.44 13.819 1993.49 194.498 1836.81 484.148C1680.14 773.798 2573.36 430.801 2573.36 430.801L2523.17 449.71",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330.91 5.19662C2330.91 5.19662 2021.7 188.812 1862.58 477.121C1703.45 765.431 2569.63 411.858 2569.63 411.858C2569.64 411.862 2520.97 431.368 2520.97 431.368",
    stroke: "#1351D8",
    strokeOpacity: 0.12,
    strokeWidth: 0.877694
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape5);
export default __webpack_public_path__ + "static/media/bg-shape-5.89ef4563dbc99033e153bb8af18b8162.svg";
export { ForwardRef as ReactComponent };